import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const CollectionsGrid = ({ collections }) => {
  if (!collections?.length) return null;

  return (
    <section className="py-20 md:py-32 px-6 md:px-12" data-testid="collections-grid">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div>
            <p className="b2t-overline mb-3">Featured Collections</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-navy max-w-xl leading-[1.05]">
              Built for the long days.<br />
              <span className="italic font-light text-seafoam-600">Dialed</span> for the good ones.
            </h2>
          </div>
          <Link
            to="/shop"
            data-testid="collections-view-all"
            className="text-sm font-bold uppercase tracking-[0.18em] text-navy hover:text-seafoam-600 transition-colors inline-flex items-center gap-2 self-start md:self-end"
          >
            View All
            <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 md:gap-6">
          {collections.map((c, idx) => (
            <Link
              key={c.slug}
              to={`/collections/${c.slug}`}
              data-testid={`collection-card-${c.slug}`}
              className={`group relative overflow-hidden bg-sand h-[340px] md:h-[440px] ${c.span || "lg:col-span-6"}`}
              style={{ animationDelay: `${idx * 80}ms` }}
            >
              <img
                src={c.image}
                alt={c.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1100ms] ease-out group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/85 via-navy/30 to-transparent" />
              <div className="absolute inset-0 p-7 md:p-9 flex flex-col justify-between text-white">
                <span className="b2t-overline !text-white/80 !text-[10px]">{c.tagline}</span>
                <div className="flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display text-2xl md:text-3xl font-bold leading-tight">{c.name}</h3>
                    <p className="text-sm text-white/70 mt-2 max-w-sm hidden md:block">{c.description}</p>
                  </div>
                  <div className="bg-white/0 group-hover:bg-seafoam transition-colors duration-300 p-3 border border-white/40 group-hover:border-seafoam">
                    <ArrowUpRight className="w-5 h-5" strokeWidth={1.5} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
